export default __webpack_public_path__ + "static/iitd_logo-0bd639cdcb5e96d05a82b18b2e274bd2.png";